import { StepCounterType } from '../../types/state';

const STEP_NEXT = 'STEP_NEXT';
const STEP_PREVIOUS = 'STEP_PREVIOUS';
const STEP_GO_TO = 'STEP_GO_TO';
const STEP_RESET_SUBSTEPS = 'STEP_RESET_SUBSTEPS';
type STEP_NEXT = typeof STEP_NEXT;
type STEP_PREVIOUS = typeof STEP_PREVIOUS;
type STEP_GO_TO = typeof STEP_GO_TO;
type STEP_RESET_SUBSTEPS = typeof STEP_RESET_SUBSTEPS;

export interface INextStep {
    type: STEP_NEXT;
    payload: StepCounterType;
}

export interface IPreviousStep {
    type: STEP_PREVIOUS;
    payload: StepCounterType;
}

export interface IGoToStep {
    type: STEP_GO_TO;
    stepNumber: number;
    counter: StepCounterType;
}

export interface IResetSubSteps {
    type: STEP_RESET_SUBSTEPS;
}

export function nextStep(counter: StepCounterType = 'main'): INextStep {
    return {
        type: STEP_NEXT,
        payload: counter,
    };
}

export function previousStep(counter: StepCounterType = 'main'): IPreviousStep {
    return {
        type: STEP_PREVIOUS,
        payload: counter,
    };
}

export function resetSubStep(): IResetSubSteps {
    return {
        type: STEP_RESET_SUBSTEPS,
    };
}

export function goToStep(
    stepNumber: number,
    counter: StepCounterType = 'main'
): IGoToStep {
    return {
        type: STEP_GO_TO,
        stepNumber,
        counter,
    };
}
